import { ref } from "vue";

import type { rawFilterSet } from "@/types/ui.ts";

import { useFilterTermSets } from "../api/content.ts";

const filterTermSet = ref<rawFilterSet | null>(null);
const { data, execute, isFetching, onFetchFinally } = useFilterTermSets({
  immediate: false,
});

export default function useFilterTermSet() {
  if (filterTermSet.value) return filterTermSet;
  if (isFetching.value) return data;

  (async () => {
    await execute();
  })();

  onFetchFinally(() => {
    filterTermSet.value = data.value;
  });

  return data;
}
